export default "__VITE_PUBLIC_ASSET__476e7acd__"